import React from "react";

const Features = () => {
  const features = [
    {
      title: "Priority Support & SLAs",
      description:
        "24/7 dedicated support with guaranteed response times and enterprise-grade service level agreements.",
    },
    {
      title: "Custom Integration & API Access",
      description:
        "Full API access and tailored integrations engineered to match your existing workflows and technology stack.",
    },
    {
      title: "Briefings & Strategy Sessions",
      description:
        "Quarterly executive briefings and strategic reviews to maximize the value of your AI transformation.",
    },
  ];

  return (
    <div className="bg-gray-50 py-10 sm:py-20 lg:py-20 text-black">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-500 mb-4">
            Premium Access
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin">
            Exclusive <em className="text-gray-400">Enterprise Features</em>
          </h2>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {features.map((feature, i) => (
            <div key={i} className="text-center">
              <div className="w-px h-14 sm:h-16 bg-gradient-to-b from-transparent via-black to-transparent mx-auto mb-6 sm:mb-8"></div>
              <h3 className="text-md sm:text-lg font-light mb-3 sm:mb-4 tracking-wide">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed font-light text-sm sm:text-sm">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
